import { createSvgComponent } from "../../icon/createSvgComponent";
import Kebab from "@core/__generated__/icon/figma/kebab.svg";
export default createSvgComponent(Kebab);